import React from 'react';
import { observer } from "mobx-react";
import { ShowableCart } from 'ReactApp/Ddd/Aggregates/ShowableCart';

type CartOrderErrorV1Props = {
    showableCart: ShowableCart
}

const CartOrderErrorV1 = observer((props: CartOrderErrorV1Props) => {

    return (
        <div 
            className="cart-order-error-v1" 
            id="cart-order-error-v1"
            >
            {
                props.showableCart.orderErrors.length > 0 
                    &&
                (<div 
                    className="
                        info-block-v1 
                        box-v1 
                        box-v1_filling-type-contained 
                        box-v1_filling-color-type-gray 
                        info-block-v1_text-color-type-text
                        _alert _alert-error
                    "
                    id='cart-order-error-v1'
                    style={{
                        marginBottom: '3rem'
                    }}
                    >
                        <div className="info-block-v1__content">
                            <h2>
                                При создании заказа возникли следующие ошибки:
                            </h2>
                            {props.showableCart.orderErrors.map((error) => (
                                <p className="p-v1 p-v1_text-color-type-text _alert _alert-error" style={{
                                    lineHeight: '3rem', marginBottom: '0.5rem',
                                }}>
                                    {error}
                                </p>
                            ))}
                        </div>
                </div>)
            }
        </div>
    );    

})

export default CartOrderErrorV1;